export default "__VITE_ASSET__BoeA$gl$__"